import { ChevronLeft } from "@mui/icons-material";
import { Breadcrumbs, Typography, styled } from "@mui/material";
import { ReactNode } from "react";
import route from "../../Router";
import { isMobile } from "../../utils";

export const DataBreadcrumbs = styled(Breadcrumbs)(() => {
    const ism = isMobile();
    return {
        marginBottom: '1rem',
        "& li > *": {
            fontSize: ism ? undefined : '1.5rem',
            display: 'flex',
            alignItems: 'center',
            color: ism ? undefined : 'rgba(0, 0, 0, 0.87)',
            "& svg": {
                height: '.875em',
                width: '.875em'
            }
        },
        "& li:not(:last-child)": {
            cursor: 'pointer'
        }
    }
});

export function TopBarBreadcrumbs({ title, children, needBack }: { title: ReactNode, children?: ReactNode, needBack?: boolean }) {
    const ism = isMobile();
    if (needBack === undefined) {
        needBack = ism && (route.get('page') !== route.getPath());
    }

    return <DataBreadcrumbs sx={{ mb: 0, py: 1 }}>
        <Typography
            variant={ism ? 'body2' : 'h5'}
            color={ism && needBack ? 'primary' : 'textPrimary'}
            fontWeight={ism ? needBack ? 500 : 600 : undefined}
            fontSize={ism ? needBack ? 14 : 16 : undefined}
            onClick={needBack ? () => window.history?.back() : undefined}>
            {needBack ? <ChevronLeft /> : null}{title}
        </Typography>
    </DataBreadcrumbs>;
}